import { render, staticRenderFns } from "./Rakamlar.vue?vue&type=template&id=c71012b4&scoped=true&"
import script from "./Rakamlar.vue?vue&type=script&lang=js&"
export * from "./Rakamlar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c71012b4",
  null
  
)

export default component.exports